import { map } from "leaflet";
import React, { useState } from "react";
import toast from "react-hot-toast";
import profile from "../../../assets/img/Home/profile.png";
import useFetch from "../../../hooks/useAxios";

const UserReserveRow = ({i,getApi}) =>{
  const postaccepted = useFetch({
    method: "post",
    url: `api/host/reserves/accept/${i.id}`,
    noHeader: false,
    trigger: false,
    caller:getApi,
    
    argFunc:res=>{
 toast.success("رزرو به حالت تایید شده در آمد")
    }
  });
  const postunaccepted = useFetch({
    method: "post",
    url: `api/host/reserves/un-accept/${i.id}`,
    noHeader: false,
    trigger: false,
    caller:getApi
  });
  return(
    <div className="UserReserve--table--body">
    <div className="flex gap-[8px] items-center">
      <img src={i.avatar} />
      <div>
        {i.user.full_name}
      </div>
    </div>
    <div className="bg-[#DCE1E3] rounded-[12px] p-[10px] font-[500] w-max">
      {i.residence_title}
    </div>
    <div>
      {" "}شب {i.count_days}
    </div>
    <div>
      {i.reserve_to_date} تا {i.reserve_from_date}
    </div>
    <div>
      {i.status}
    </div>
    <div className="flex items-center gap-[10px]">
      <button className="success-button" onClick={()=>postaccepted.reFetch()}>تایید</button>
      <button  className="unsuccess-button" onClick={()=>postunaccepted.reFetch()}>رد</button>
    </div>
  </div>
  )
}
const UserReserveTable = ({ arr ,getApi}) => {
 
  return (
    <div className="UserReserve--table">
      <div className="UserReserve--table--head">
        <div>متقاضی</div>
        <div>نام اقامتگاه</div>
        <div>شب های اقامت</div>
        <div>تاریخ درخواست</div>
        <div>وضعیت</div>
      </div>
      {arr.map(i =>
       <UserReserveRow getApi={getApi} i={i} />
      )}
    </div>
  );
};
const UserReserve = () => {
  const [all, setAll] = useState([]);
  const [current, setcurrent] = useState([]);
  const [accepted, setaccepted] = useState([]);
  const [canceled, setcanceled] = useState([]);

  const fetchALL = useFetch({
    method: "get",
    url: "api/host/reserves/all",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setAll(res.data.reserves);
    }
  });
  const fetchcurrent = useFetch({
    method: "get",
    url: "api/host/reserves/in-progress",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setcurrent(res.data.reserves);
    }
  });
  const fetchaccepted = useFetch({
    method: "get",
    url: "api/host/reserves/successful",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setaccepted(res.data.reserves);
    }
  });
  const fetchcanceled = useFetch({
    method: "get",
    url: "api/host/reserves/unsuccessfully",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setcanceled(res.data.reserves);
    }
  });

  const [tab, settab] = useState("all"); //all//current//accepted//canceled

  return (
    <div className="UserReserve">
      <h3>درخواست های رزرو شما</h3>

      <div className="UserReserve--tab-box">
        <button
          className={`UserReserve-tab ${tab === "all"
            ? "UserReserve-tab-active"
            : ""}`}
          onClick={() => settab("all")}
        >
          <div>همه درخواست ها</div>
        </button>
        <button
          className={`UserReserve-tab ${tab === "current"
            ? "UserReserve-tab-active"
            : ""}`}
          onClick={() => settab("current")}
        >
          <div>درخواست های جاری</div>
        </button>
        <button
          className={`UserReserve-tab ${tab === "accepted"
            ? "UserReserve-tab-active"
            : ""}`}
          onClick={() => settab("accepted")}
        >
          <div>درخواست های قبول شده</div>
        </button>
        <button
          className={`UserReserve-tab ${tab === "canceled"
            ? "UserReserve-tab-active"
            : ""}`}
          onClick={() => settab("canceled")}
        >
          <div>درخواست های لغو شده</div>
        </button>
      </div>
      {tab === "all"
        ? all.length > 0 ? <UserReserveTable arr={all} /> : <p></p>
        : tab === "current"
          ? current.length > 0
            ? <UserReserveTable getApi={fetchALL} arr={current} />
            : <p></p>
          : tab === "accepted"
            ? accepted.length > 0
              ? <UserReserveTable getApi={fetchaccepted} arr={accepted} />
              : <p></p>
            : tab === "canceled"
              ? canceled.length > 0
                ? <UserReserveTable getApi={fetchcanceled} arr={canceled} />
                : <p></p>
              : null}
    </div>
  );
};

export default UserReserve;
